export const FormatsData: {[k: string]: ModdedSpeciesFormatsData} = {
	bulbasaur: {
		tier: "LC",
	},
	ivysaur: {
		tier: "NFE",
	},
	venusaur: {
		tier: "UUBL",
	},
	charmander: {
		tier: "LC",
	},
	charmeleon: {
		tier: "NFE",
	},
	charizard: {
		tier: "UUBL",
	},
	squirtle: {
		tier: "LC",
	},
	wartortle: {
		tier: "NFE",
	},
	blastoise: {
		tier: "UU",
	},
	caterpie: {
		tier: "LC",
	},
	metapod: {
		tier: "NFE",
	},
	butterfree: {
		tier: "NU",
	},
	weedle: {
		tier: "LC",
	},
	kakuna: {
		tier: "NFE",
	},
	beedrill: {
		tier: "NU",
	},
	pidgey: {
		tier: "LC",
	},
	pidgeotto: {
		tier: "NFE",
	},
	pidgeot: {
		tier: "NU",
	},
	rattata: {
		tier: "LC",
	},
	raticate: {
		tier: "NU",
	},
	spearow: {
		tier: "LC",
	},
	fearow: {
		tier: "NU",
	},
	ekans: {
		tier: "LC",
	},
	arbok: {
		tier: "NU",
	},
	pichu: {
		tier: "LC",
	},
	pikachu: {
		tier: "UU",
	},
	raichu: {
		tier: "NUBL",
	},
	sandshrew: {
		tier: "LC",
	},
	sandslash: {
		tier: "UU",
	},
	nidoranf: {
		tier: "LC",
	},
	nidorina: {
		tier: "NFE",
	},
	nidoqueen: {
		tier: "UU",
	},
	nidoranm: {
		tier: "LC",
	},
	nidorino: {
		tier: "NFE",
	},
	nidoking: {
		tier: "OU",
	},
	cleffa: {
		tier: "LC",
	},
	clefairy: {
		tier: "NFE",
	},
	clefable: {
		tier: "UUBL",
	},
	vulpix: {
		tier: "LC",
	},
	ninetales: {
		tier: "NU",
	},
	igglybuff: {
		tier: "LC",
	},
	jigglypuff: {
		tier: "NFE",
	},
	wigglytuff: {
		tier: "NU",
	},
	zubat: {
		tier: "LC",
	},
	golbat: {
		tier: "NFE",
	},
	crobat: {
		tier: "UU",
	},
	oddish: {
		tier: "LC",
	},
	gloom: {
		tier: "NU",
	},
	vileplume: {
		tier: "UU",
	},
	bellossom: {
		tier: "UU",
	},
	paras: {
		tier: "LC",
	},
	parasect: {
		tier: "NU",
	},
	venonat: {
		tier: "LC",
	},
	venomoth: {
		tier: "NU",
	},
	diglett: {
		tier: "LC",
	},
	dugtrio: {
		tier: "NU",
	},
	meowth: {
		tier: "LC",
	},
	persian: {
		tier: "NU",
	},
	psyduck: {
		tier: "LC",
	},
	golduck: {
		tier: "NUBL",
	},
	mankey: {
		tier: "LC",
	},
	primeape: {
		tier: "NU",
	},
	growlithe: {
		tier: "LC",
	},
	arcanine: {
		tier: "UU",
	},
	poliwag: {
		tier: "LC",
	},
	poliwhirl: {
		tier: "NU",
	},
	poliwrath: {
		tier: "NUBL",
	},
	politoed: {
		tier: "UU",
	},
	abra: {
		tier: "LC",
	},
	kadabra: {
		tier: "UU",
	},
	alakazam: {
		tier: "UUBL",
	},
	machop: {
		tier: "LC",
	},
	machoke: {
		tier: "NU",
	},
	machamp: {
		tier: "OU",
	},
	bellsprout: {
		tier: "LC",
	},
	weepinbell: {
		tier: "NFE",
	},
	victreebel: {
		tier: "UU",
	},
	tentacool: {
		tier: "NU",
	},
	tentacruel: {
		tier: "UUBL",
	},
	geodude: {
		tier: "LC",
	},
	graveler: {
		tier: "NU",
	},
	golem: {
		tier: "OU",
	},
	ponyta: {
		tier: "LC",
	},
	rapidash: {
		tier: "NU",
	},
	slowpoke: {
		tier: "NU",
	},
	slowbro: {
		tier: "UU",
	},
	slowking: {
		tier: "UU",
	},
	magnemite: {
		tier: "NU",
	},
	magneton: {
		tier: "UU",
	},
	farfetchd: {
		tier: "NU",
	},
	doduo: {
		tier: "LC",
	},
	dodrio: {
		tier: "UU",
	},
	seel: {
		tier: "LC",
	},
	dewgong: {
		tier: "NU",
	},
	grimer: {
		tier: "LC",
	},
	muk: {
		tier: "UUBL",
	},
	shellder: {
		tier: "LC",
	},
	cloyster: {
		tier: "OU",
	},
	gastly: {
		tier: "NU",
	},
	haunter: {
		tier: "UU",
	},
	gengar: {
		tier: "OU",
	},
	onix: {
		tier: "LC",
	},
	steelix: {
		tier: "OU",
	},
	drowzee: {
		tier: "LC",
	},
	hypno: {
		tier: "UU",
	},
	krabby: {
		tier: "LC",
	},
	kingler: {
		tier: "NU",
	},
	voltorb: {
		tier: "NU",
	},
	electrode: {
		tier: "UU",
	},
	exeggcute: {
		tier: "NU",
	},
	exeggutor: {
		tier: "OU",
	},
	cubone: {
		tier: "NU",
	},
	marowak: {
		tier: "OU",
	},
	tyrogue: {
		tier: "LC",
	},
	hitmonlee: {
		tier: "NU",
	},
	hitmonchan: {
		tier: "NU",
	},
	hitmontop: {
		tier: "NU",
	},
	lickitung: {
		tier: "NU",
	},
	koffing: {
		tier: "LC",
	},
	weezing: {
		tier: "NU",
	},
	rhyhorn: {
		tier: "LC",
	},
	rhydon: {
		tier: "OU",
	},
	chansey: {
		tier: "UU",
	},
	blissey: {
		tier: "OU",
	},
	tangela: {
		tier: "NU",
	},
	kangaskhan: {
		tier: "UUBL",
	},
	horsea: {
		tier: "LC",
	},
	seadra: {
		tier: "NU",
	},
	kingdra: {
		tier: "UUBL",
	},
	goldeen: {
		tier: "LC",
	},
	seaking: {
		tier: "NU",
	},
	staryu: {
		tier: "LC",
	},
	starmie: {
		tier: "OU",
	},
	mrmime: {
		tier: "UU",
	},
	scyther: {
		tier: "UU",
	},
	scizor: {
		tier: "UUBL",
	},
	smoochum: {
		tier: "LC",
	},
	jynx: {
		tier: "OU",
	},
	elekid: {
		tier: "NU",
	},
	electabuzz: {
		tier: "UU",
	},
	magby: {
		tier: "LC",
	},
	magmar: {
		tier: "NU",
	},
	pinsir: {
		tier: "UU",
	},
	tauros: {
		tier: "UUBL",
	},
	magikarp: {
		tier: "LC",
	},
	gyarados: {
		tier: "UU",
	},
	lapras: {
		tier: "UUBL",
	},
	ditto: {
		tier: "NU",
	},
	eevee: {
		tier: "LC",
	},
	vaporeon: {
		tier: "OU",
	},
	jolteon: {
		tier: "UUBL",
	},
	flareon: {
		tier: "NU",
	},
	espeon: {
		tier: "UUBL",
	},
	umbreon: {
		tier: "OU",
	},
	porygon: {
		tier: "NU",
	},
	porygon2: {
		tier: "UUBL",
	},
	omanyte: {
		tier: "LC",
	},
	omastar: {
		tier: "UU",
	},
	kabuto: {
		tier: "LC",
	},
	kabutops: {
		tier: "UU",
	},
	aerodactyl: {
		tier: "UUBL",
	},
	snorlax: {
		tier: "OU",
	},
	articuno: {
		tier: "UUBL",
	},
	zapdos: {
		tier: "OU",
	},
	moltres: {
		tier: "UUBL",
	},
	dratini: {
		tier: "LC",
	},
	dragonair: {
		tier: "NU",
	},
	dragonite: {
		tier: "UUBL",
	},
	mewtwo: {
		tier: "Uber",
	},
	mew: {
		tier: "Uber",
	},
	chikorita: {
		tier: "LC",
	},
	bayleef: {
		tier: "NU",
	},
	meganium: {
		tier: "UUBL",
	},
	cyndaquil: {
		tier: "LC",
	},
	quilava: {
		tier: "NFE",
	},
	typhlosion: {
		tier: "UUBL",
	},
	totodile: {
		tier: "LC",
	},
	croconaw: {
		tier: "NFE",
	},
	feraligatr: {
		tier: "NUBL",
	},
	sentret: {
		tier: "LC",
	},
	furret: {
		tier: "NU",
	},
	hoothoot: {
		tier: "LC",
	},
	noctowl: {
		tier: "NU",
	},
	ledyba: {
		tier: "LC",
	},
	ledian: {
		tier: "NU",
	},
	spinarak: {
		tier: "LC",
	},
	ariados: {
		tier: "NU",
	},
	chinchou: {
		tier: "NU",
	},
	lanturn: {
		tier: "UU",
	},
	togepi: {
		tier: "LC",
	},
	togetic: {
		tier: "NU",
	},
	natu: {
		tier: "LC",
	},
	xatu: {
		tier: "NU",
	},
	mareep: {
		tier: "LC",
	},
	flaaffy: {
		tier: "NU",
	},
	ampharos: {
		tier: "UU",
	},
	marill: {
		tier: "LC",
	},
	azumarill: {
		tier: "NU",
	},
	sudowoodo: {
		tier: "NU",
	},
	hoppip: {
		tier: "LC",
	},
	skiploom: {
		tier: "NFE",
	},
	jumpluff: {
		tier: "UU",
	},
	aipom: {
		tier: "NU",
	},
	sunkern: {
		tier: "LC",
	},
	sunflora: {
		tier: "NU",
	},
	yanma: {
		tier: "NU",
	},
	wooper: {
		tier: "LC",
	},
	quagsire: {
		tier: "UU",
	},
	murkrow: {
		tier: "NU",
	},
	misdreavus: {
		tier: "OU",
	},
	unown: {
		tier: "NU",
	},
	wobbuffet: {
		tier: "NU",
	},
	girafarig: {
		tier: "UU",
	},
	pineco: {
		tier: "NU",
	},
	forretress: {
		tier: "OU",
	},
	dunsparce: {
		tier: "NU",
	},
	gligar: {
		tier: "UU",
	},
	snubbull: {
		tier: "LC",
	},
	granbull: {
		tier: "UU",
	},
	qwilfish: {
		tier: "UU",
	},
	shuckle: {
		tier: "NU",
	},
	heracross: {
		tier: "OU",
	},
	sneasel: {
		tier: "NU",
	},
	teddiursa: {
		tier: "LC",
	},
	ursaring: {
		tier: "UUBL",
	},
	slugma: {
		tier: "LC",
	},
	magcargo: {
		tier: "NU",
	},
	swinub: {
		tier: "LC",
	},
	piloswine: {
		tier: "UU",
	},
	corsola: {
		tier: "NU",
	},
	remoraid: {
		tier: "LC",
	},
	octillery: {
		tier: "NU",
	},
	delibird: {
		tier: "NU",
	},
	mantine: {
		tier: "NU",
	},
	skarmory: {
		tier: "OU",
	},
	houndour: {
		tier: "NU",
	},
	houndoom: {
		tier: "UUBL",
	},
	phanpy: {
		tier: "LC",
	},
	donphan: {
		tier: "UUBL",
	},
	stantler: {
		tier: "NU",
	},
	smeargle: {
		tier: "UUBL",
	},
	miltank: {
		tier: "OU",
	},
	raikou: {
		tier: "OU",
	},
	entei: {
		tier: "UUBL",
	},
	suicune: {
		tier: "OU",
	},
	larvitar: {
		tier: "LC",
	},
	pupitar: {
		tier: "NU",
	},
	tyranitar: {
		tier: "OU",
	},
	lugia: {
		tier: "Uber",
	},
	hooh: {
		tier: "Uber",
	},
	celebi: {
		tier: "Uber",
	},
};
